
export const postStyle = {
	whiteSpace: 'pre-wrap',
};


export const initialPateintFormInputColor = {
	phn: 'lightgrey',
	firstName: 'lightgrey',
	lastName: 'lightgrey'
}

export const customStyles = {
	control: (provided) => ({
		...provided,
		height: 42,
		paddingLeft: '4.8px',
		color: '#6B7280',
		borderRadius: '4px',
		position: 'relative',
		'&:hover': {
			border: '1px solid lightgrey',
			outline: 'none'
		},
		'&:focus': {
			border: '1px solid lightgrey',
			outline: 'none'
		}
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: '200px',
		overflowY: 'auto',
	}),
	menu: (provided) => ({
		...provided,
		maxHeight: '200px',
		overflowY: 'hidden',
	}),
};

export const customSelectStyles = {
	control: (provided) => ({
		...provided,
		height: 46,
		paddingLeft: '13px',
		color: '#6B7280',
		borderRadius: '8px',
		position: 'relative',
		top: '17.4px'
	}),

	menuList: (provided) => ({
		...provided,
		maxHeight: '200px',
		overflowY: 'auto',
	}),
	menu: (provided) => ({
		...provided,
		marginTop: '20px',
		maxHeight: '200px',
		overflowY: 'hidden',
	}),
};

export const customSearchStyle = {
	control: (provided) => ({
		...provided,
		height: 46,
		paddingLeft: '13px',
		color: '#6B7280',
		borderRadius: '8px',
		position: 'relative',
	}),

	menuList: (provided) => ({
		...provided,
		maxHeight: '200px',
		overflowY: 'auto',
	}),
	menu: (provided) => ({
		...provided,
		maxHeight: '200px',
		overflowY: 'hidden',
	}),
};

export const filterSelectStyles = {
	control: (base, state) => ({
		...base,
		minHeight: '38px',
		height: '38px',
		borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
		borderRadius: '6px',
		boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
		'&:hover': {
			borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
		},
	}),
	valueContainer: (base) => ({
		...base,
		height: '38px',
		padding: '0 12px',
	}),
	input: (base) => ({
		...base,
		margin: 0,
		padding: 0,
	}),
	indicatorsContainer: (base) => ({
		...base,
		height: '38px',
	}),
	indicatorSeparator: () => ({
		display: 'none',
	}),
	dropdownIndicator: (base) => ({
		...base,
		padding: '8px',
		color: '#6b7280',
	}),
	menu: (base) => ({
		...base,
		zIndex: 50,
	}),
};


export const customPatientListStyle = {
	control: (provided) => ({
		...provided,
		height: 46,
		paddingLeft: '13px',
		color: '#6B7280',
		borderRadius: '8px',
		position: 'relative',
	}),

	menuList: (provided) => ({
		...provided,
		maxHeight: '200px',
		overflowY: 'auto',
	}),
	menu: (provided) => ({
		...provided,
		maxHeight: '200px',
		overflowY: 'hidden',
	}),
};

export const varianceReasonSelectStyles = {
	control: (provided, state) => ({
		...provided,
		minHeight: '32px',
		height: '32px',
		border: `1px solid ${state.isFocused ? '#2463eb' : '#d8e1ee'}`,
		borderRadius: '6px',
		boxShadow: 'none',
		backgroundColor: state.isDisabled ? '#f8fbff' : '#fff',
		cursor: state.isDisabled ? 'not-allowed' : 'pointer',
		'&:hover': {
			borderColor: state.isDisabled ? '#d8e1ee' : '#2463eb',
		},
	}),
	valueContainer: (provided) => ({
		...provided,
		minHeight: '30px',
		height: '30px',
		padding: '0 8px',
	}),
	input: (provided) => ({
		...provided,
		margin: 0,
		padding: 0,
	}),
	placeholder: (provided) => ({
		...provided,
		color: '#68778e',
		fontSize: '14px',
		fontWeight: 500,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	}),
	singleValue: (provided) => ({
		...provided,
		color: '#17213a',
		fontSize: '14px',
		fontWeight: 600,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	}),
	option: (provided, state) => ({
		...provided,
		fontSize: '14px',
		lineHeight: '18px',
		padding: '7px 10px',
		backgroundColor: state.isSelected ? '#2463eb' : state.isFocused ? '#eef5ff' : '#fff',
		color: state.isSelected ? '#fff' : '#17213a',
		cursor: 'pointer',
		whiteSpace: 'normal',
	}),
	menu: (provided) => ({
		...provided,
		zIndex: 30,
		width: '320px',
		borderRadius: '8px',
		border: '1px solid #d8e1ee',
		boxShadow: '0 10px 24px rgba(15, 23, 42, 0.12)',
		overflow: 'hidden',
	}),
	menuPortal: (provided) => ({
		...provided,
		zIndex: 9999,
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: '210px',
		padding: '4px',
	}),
	indicatorsContainer: (provided) => ({
		...provided,
		height: '30px',
	}),
	indicatorSeparator: () => ({
		display: 'none',
	}),
	dropdownIndicator: (provided) => ({
		...provided,
		padding: '0 8px',
		color: '#68778e',
	}),
};

export const mediCationStyle = {
	control: (provided) => ({
		...provided,
		height: 42,
		paddingLeft: '4.8px',
		color: '#6B7280',
		borderRadius: '4px',
		position: 'relative',
		marginTop: '30px',
		marginBottom: '-20px'
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: '200px',
		overflowY: 'auto',
	}),
	menu: (provided) => ({
		...provided,
		maxHeight: '200px',
		overflowY: 'hidden',
	}),
}

export const authLoginStyle = {
	control: (provided) => ({
		...provided,
		height: 48,
		paddingLeft: '13px',
		color: 'gray',
		position: 'relative',
	}),

	menuList: (provided) => ({
		...provided,
		maxHeight: '200px',
		overflowY: 'auto',
	}),
	menu: (provided) => ({
		...provided,
		marginTop: '4px',
		maxHeight: '200px',
		overflowY: 'hidden',
	}),
}

export const TopHeaderSearchStyle = {
	control: (provided) => ({
		...provided,
		height: '46px',
		borderRadius: '8px',
		position: 'relative',
		width: '110px',
		borderColor: 'transparent !important',
		boxShadow: 'none !important',
		borderTopRightRadius: '0px',
		borderBottomRightRadius: '0px'

	}),

	menuList: (provided) => ({
		...provided,
		maxHeight: '200px',
		maxWidth: '200px',
		overflowY: 'auto',
	}),
	menu: (provided) => ({
		...provided,
		maxHeight: '200px',
		maxWidth: '200px',
		overflowY: 'hidden',
	}),
}


export const initialARVFormInputColor = {
	patientPhone: "lightgrey",
	patientFirstName: "lightgrey",
	patientLastName: "lightgrey",
	PatientDob: "lightgrey",
	drugName: "lightgrey",
	dueInDays: "lightgrey",
	name: 'lightgrey',
	fetchType: 'lightgrey',
	duein: 'lightgrey',
};

export const initialARVFormDrugColor = {
	drugName: "lightgrey",
	dueInDays: "lightgrey",
};

export const VisitReasonStyle = {
	control: (provided) => ({
		...provided,

		padding: "5px 0px 5px 0px",
		color: "#282828",
		borderRadius: "5px",
		position: "relative",
		border: "1px solid lightgrey",
		outline: "none",
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: "200px",
		overflowY: "auto",
	}),
	menu: (provided) => ({
		...provided,
		maxHeight: "200px",
		overflowY: "hidden",
	}),
}

export const BlisterDropDownStyle = {
	control: (provided, state) => ({
		...provided,
		fontSize: '14px',
		color: "#6B7280",
		borderRadius: "4px",
		position: "relative",
		border: "1px solid lightgrey",
		boxShadow: 'none',
		whiteSpace: 'nowrap',
		minWidth: 'fit-content',
		"&:hover": {
			borderColor: "#2563eb",
			outline: 'none',
			boxShadow: 'none',
		}
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: "200px",
		overflowY: "auto",
		fontSize: '14px',
		padding: '0px',
		minWidth: '200px',
	}),
	menu: (provided) => ({
		...provided,
		minWidth: '200px',
		maxHeight: "200px",
		zIndex: 9999,
	}),
	menuPortal: (provided) => ({
		...provided,
		zIndex: 9999,
	}),

	dropdownIndicator: (provided) => ({
		...provided,
		padding: '0px 4px 0px 0px',    // Optional: adjust padding

	}),
	placeholder: (provided) => ({
		...provided,
		whiteSpace: 'nowrap',
	}),
	singleValue: (provided) => ({
		...provided,
		whiteSpace: 'nowrap',
		maxWidth: 'none',
	})
}


export const BlisterVialsMedicationRouteStyle = {
	control: (provided) => ({
		...provided,
		width: '75px',
		fontSize: '14px',
		color: "#6B7280",
		borderRadius: "0px",
		position: "relative",
		borderLeft: 'none',
		borderTop: 'none',
		borderRight: 'none',
		borderBottom: '1px solid #6b7280',
		boxShadow: 'none',
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: "200px",
		overflowY: "auto",
		fontSize: '14px',
		padding: '0px',
		width: '200px',
	}),
	menu: (provided) => ({
		...provided,
		width: '200px',
		maxHeight: "200px",
	}),

	dropdownIndicator: (provided) => ({
		...provided,
		padding: '0px 0px 0px 0px',
		width: '12px',
		color: '#6b7280',   // Optional: adjust padding

	})
}

export const BlisterVialsMedicationFacilityStyle = {
	control: (provided) => ({
		...provided,
		width: '85px',
		fontSize: '14px',
		color: "#6b7280",
		borderRadius: "0px",
		position: "relative",
		borderLeft: 'none',
		borderTop: 'none',
		borderRight: 'none',
		borderBottom: '1px solid #6b7280',
		boxShadow: 'none',
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: "200px",
		overflowY: "auto",
		fontSize: '14px',
		padding: '0px',
		width: '200px',
	}),
	menu: (provided) => ({
		...provided,
		width: '200px',
		maxHeight: "200px",
	}),

	dropdownIndicator: (provided) => ({
		...provided,
		padding: '0px ',
		width: '12px',
		color: '#6b7280',   // Optional: adjust padding
	})
}


export const RouteStyle = {
	control: (provided) => ({
		...provided,
		fontSize: '14px',
		color: "#6B7280",
		borderRadius: "4px",
		position: "relative",
		border: "1px solid lightgrey",
	}),
	menuList: (provided) => ({
		...provided,
		width: '200px',
		maxHeight: "200px",
		overflowY: "auto",
		fontSize: '14px',
		padding: '0px'
	}),
	menu: (provided) => ({
		...provided,
		width: '200px',
		maxHeight: "200px",
		overflowY: "hidden",
	}),

	dropdownIndicator: (provided) => ({
		...provided,
		padding: '0px 4px 0px 0px',    // Optional: adjust padding

	}),

}

/** Note Option & System Generated Notes dropdowns - same style for both (white bg, dark text, consistent width) */
export const NoteOptionDropdownStyle = {
	...RouteStyle,
	control: (provided) => ({
		...RouteStyle.control(provided),
		minWidth: '220px',
		backgroundColor: '#ffffff',
		color: '#374151',
	}),
	singleValue: (provided) => ({
		...provided,
		color: '#374151',
	}),
	placeholder: (provided) => ({
		...provided,
		color: '#6B7280',
	}),
}


export const SelectReasonStyle = {
	control: (provided) => ({
		...provided,
		width: '200px',
		fontSize: '14px',
		border: '1px solid lightgrey',
		borderRadius: '0.375rem',
		boxShadow: 'none',
		'&:hover': {
			border: '1px solid lightgrey'
		}
	}),
	placeholder: (provided) => ({
		...provided,
		color: '#94a3b8'
	}),
	menu: (provided) => ({
		...provided,
		border: '1px solid lightgrey',
		borderRadius: '0.375rem',
		boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
	})
}

export const VerifyPharmacistStyle = {
	control: (provided) => ({
		...provided,
		width: '100px',
		fontSize: '14px',
		border: '1px solid lightgrey',
		borderRadius: '0.375rem',
		boxShadow: 'none',
		'&:hover': {
			border: '1px solid lightgrey'
		}
	}),
	placeholder: (provided) => ({
		...provided,
		color: '#94a3b8'
	}),
	menu: (provided) => ({
		...provided,
		// border: '1px solid lightgrey',
		borderRadius: '0.375rem',
		boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
	})
}

export const MedicationStyle = {
	control: (provided) => ({
		...provided,
		height: 28,
		fontSize: '14px',
		paddingLeft: "4px",
		color: "#6B7280",
		borderRadius: "4px",
		position: "relative",
		border: "1px solid lightgrey",
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: "200px",
		overflowY: "auto",
	}),
	menu: (provided) => ({
		...provided,
		marginTop: "2px",
		fontSize: '14px',
		maxHeight: "200px",
		overflowY: "hidden",
	}),
}

export const ScheduleStyle = {
	control: (provided) => ({
		...provided,
		height: 28,
		fontSize: '14px',
		paddingLeft: "4px",
		color: "#6B7280",
		borderRadius: "4px",
		position: "relative",
		border: "1px solid lightgrey",
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: "200px",
		overflowY: "auto",
	}),
	menu: (provided) => ({
		...provided,
		marginTop: "2px",
		fontSize: '14px',
		maxHeight: "200px",
		overflowY: "hidden",
	}),
}


export const FacilityStyle = {
	control: (provided) => ({
		...provided,
		height: 45,
		fontSize: '14px',
		paddingLeft: "11px",
		borderRadius: "8px",
		color: "#6B7280",
		border: "1px solid lightgrey",
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: "200px",
		overflowY: "auto",
	}),
	menu: (provided) => ({
		...provided,
		marginTop: "2px",
		fontSize: '14px',
		maxHeight: "200px",
		overflowY: "hidden",
	}),
}

export const AssigneeStyle = {
	control: (provided) => ({
		...provided,
		height: 45,
		fontSize: '14px',
		paddingLeft: "11px",
		borderRadius: "8px",
		color: "#6B7280",
		border: "1px solid lightgrey",
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: "200px",
		overflowY: "auto",
	}),
	menu: (provided) => ({
		...provided,
		marginTop: "2px",
		fontSize: '14px',
		maxHeight: "200px",
		overflowY: "hidden",
	}),
}

export const updateAssigneeStyles = {
	control: (provided, state) => ({
		...provided,
		// width: "85px",
		border: '1px solid #e5e7eb',
		boxShadow: 'none',
		borderRadius: '6px',
		minHeight: '24px !important',
		"&:hover": {
			borderColor: "#e5e7eb",
		},
	}),
	option: (provided, state) => ({
		...provided,
		// width: "125px",
		minWidth: 'fit-content',
		backgroundColor: state.isSelected ? "#2563eb" : state.isFocused ? "#eff6ff" : "white",
		color: state.isSelected ? "white" : "#374151",
		padding: "4px",
	}),
	menu: (provided) => ({
		...provided,
		borderRadius: "8px",
		border: '1px solid lightgray',
		width: "180px",
		padding: "5px",
		boxShadow: "0px 5px 10px rgba(0,0,0,0.1)",
		backgroundColor: "white",
	}),
	indicatorSeparator: (provided) => ({
		...provided,
		display: "none",
	}),
	dropdownIndicator: (provided) => ({
		...provided,
		display: "none",
	}),
};

export const addAssigneeStyles = {
	control: (provided, state) => ({
		...provided,
		borderRadius: "4px",
		padding: "2px",
		boxShadow: "none",
		"&:hover": {
			borderColor: "#e5e7eb",
		},
		"&:focus": {
			borderColor: "#e5e7eb",
		},
	}),
	option: (provided, state) => ({
		...provided,
		backgroundColor: state.isSelected ? "#2563eb" : state.isFocused ? "#eff6ff" : "white",
		color: state.isSelected ? "white" : "#374151",
		padding: "10px",
		
	}),
	menu: (provided) => ({
		...provided,
		borderRadius: "8px",
		padding: "5px",
		boxShadow: "0px 5px 10px rgba(0,0,0,0.1)",
		backgroundColor: "white",
		
	}),
	multiValue: (provided) => ({
		...provided,
		backgroundColor: "#e0e7ff",
		borderRadius: "15px",
		padding: "2px 8px",
		display: "flex",
		alignItems: "center",
	}),
	multiValueLabel: (provided) => ({
		...provided,
		color: "#2563eb",
		fontWeight: "500",
	}),
	multiValueRemove: (provided) => ({
		...provided,
		color: "#2563eb",
		"&:hover": {
			backgroundColor: "#2563eb",
			color: "white",
		},
	}),
	menuPortal: base => ({ ...base, zIndex: 9999 })
};

export const medPreviewPdfStyle = {
	control: (provided) => ({
		...provided,
		width: '200px',
		fontSize: '14px',
		border: '1px solid lightgrey',
		borderRadius: '0.375rem',
		boxShadow: 'none',
		'&:hover': {
			border: '1px solid lightgrey'
		}
	}),
	placeholder: (provided) => ({
		...provided,
		color: '#3b3232'
	}),
	menu: (provided) => ({
		...provided,
		width: '240px',
		fontSize: '14px',
		border: '1px solid lightgrey',
		borderRadius: '0.375rem',
		boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
	})
}

export const DrugStyle = {
	control: (provided) => ({
		...provided,
		minWidth: '160px',
		width: 'auto',
		overflow: 'visible',
	}),
	valueContainer: (provided) => ({
		...provided,
		overflow: 'visible',
		whiteSpace: 'nowrap',
	}),
	singleValue: (provided) => ({
		...provided,
		overflow: 'visible',
		whiteSpace: 'nowrap',
		textOverflow: 'clip',
		maxWidth: 'none',
	}),
	menu: (provided) => ({
		...provided,
		width: '300px',
		fontSize: '14px',
		border: '1px solid lightgrey',
		borderRadius: '0.375rem',
		boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
	})
}


// React Select custom styles
export const InvestigationRXPDFPreviewStyle = {
	control: (provided) => ({
		...provided,
		fontSize: '14px',
		color: "#6B7280",
		borderRadius: "4px",
		position: "relative",
		border: "1px solid lightgrey",
		outline: "none",
		boxShadow: "none",
		"&:hover": {
			borderColor: "lightgrey",
		},
		"&:focus": {
			borderColor: "lightgrey",
			boxShadow: "none",
			outline: "none",
		},
		"&:active": {
			borderColor: "lightgrey",
			boxShadow: "none",
		},
		minWidth: 'fit-content',
		width: 'auto',
		maxWidth: '280px',
	}),
	menuList: (provided) => ({
		...provided,
		maxHeight: "150px",
		overflowY: "auto",
		fontSize: '14px',
		padding: '0px'
	}),
	option: (provided) => ({
		...provided,
		fontSize: '12px',
		padding: '6px 8px',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	}),
	menu: (provided) => ({
		...provided,
		maxHeight: "150px",
		width: 'fit-content',
		minWidth: '100%',
		maxWidth: '280px',
	}),

	dropdownIndicator: (provided) => ({
		...provided,
		padding: '0px 2px 0px 0px',
	}),

}



export const prepCheckLabelStyle = {
	control: (provided, state) => ({
		...provided,
		maxWidth: "120px",
		textAlign: "center",
		border: `1px solid lightgray`,
		boxShadow: 'none',
		borderRadius: '5px',
		minHeight: '30px !important',
		"&:hover": {
			borderColor: "lightgray",
			color: "white",
		},
		backgroundColor: "#004F87",

		// color: "white !important",
	}),
	singleValue: (provided, state) => ({
		...provided,
		color: "white", // <-- THIS is what you need!
		fontSize: "12px",
	}),
	option: (provided, state) => ({
		...provided,
		minWidth: 'fit-content',
		backgroundColor: state.isSelected ? "#F3F4F6" : state.isFocused ? "#eff6ff" : "white",
		color: "black",
		fontSize: "14px",
		padding: "6px",
	}),
	placeholder: (provided) => ({
		...provided,
		color: "white !important",
		fontSize: "14px",
	}),
	menu: (provided) => ({
		...provided,
		borderRadius: "0px",
		border: `1px solid lightgray`,
		width: "125px",
		boxShadow: "0px 5px 10px rgba(0,0,0,0.1)",
		backgroundColor: "white",
		marginTop: "0", // Reduce gap between control and menu
	}),
	indicatorSeparator: (provided) => ({
		...provided,
		display: "none",
	}),
	dropdownIndicator: (provided) => ({
		...provided,
		display: "none",
	}),
};

// Patient Vitals Select Styles
export const patientVitalsSelectStyles = {
	control: (base) => ({
		...base,
		minHeight: '38px',
		height: 'auto',
		minWidth: '200px',
		width: 'auto',
		borderColor: '#d1d5db',
		borderRadius: '8px',
		fontSize: '14px',
		'&:hover': {
			borderColor: '#2563eb'
		}
	}),
	placeholder: (base) => ({
		...base,
		fontSize: '14px',
		color: '#9ca3af'
	}),
	singleValue: (base) => ({
		...base,
		fontSize: '14px',
		whiteSpace: 'nowrap',
		overflow: 'visible',
		textOverflow: 'clip'
	}),
	valueContainer: (base) => ({
		...base,
		overflow: 'visible',
		whiteSpace: 'nowrap'
	}),
	input: (base) => ({
		...base,
		overflow: 'visible'
	}),
	menu: (base) => ({
		...base,
		fontSize: '14px'
	}),
	menuList: (base) => ({
		...base,
		maxHeight: '300px',
		overflowY: 'auto',
		scrollbarWidth: 'none', // Firefox
		msOverflowStyle: 'none', // IE and Edge
		'&::-webkit-scrollbar': {
			display: 'none' // Chrome, Safari, Opera
		}
	}),
	option: (base, state) => ({
		...base,
		fontSize: '14px',
		backgroundColor: state.isSelected
			? '#dbeafe'
			: state.isFocused
				? '#f3f4f6'
				: 'white',
		'&:active': {
			backgroundColor: '#dbeafe'
		}
	})
};
